import React from 'react';

const paths: Record<string, string> = {
  '/admin/dashboard': 'M3 10 12 3l9 7v10H3Z M9 20v-7h6v7',
  '/admin/apps': 'M3 3h7v7H3Z M14 3h7v7h-7Z M3 14h7v7H3Z M14 14h7v7h-7Z',
  '/admin/cities': 'M9 21 3 18V4l6 3 6-3 6 3v14l-6-3Z M9 7v14 M15 4v14',
  '/admin/products': 'M5 3h14v18H5Z M8 7h8 M8 11h8 M8 15h5',
  '/admin/ad-landings': 'M3 5h18v14H3Z M3 9h18 M7 13h4 M7 16h9',
  '/admin/cms/templates': 'M3 4h18v16H3Z M3 9h18 M9 9v11',
  '/admin/orders': 'M6 3h12v18l-3-2-3 2-3-2-3 2Z M9 7h6 M9 11h6 M9 15h4',
  '/admin/members':
    'M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 21v-3a7 7 0 0 1 14 0v3 M3 8a3 3 0 0 0 0 6 M21 8a3 3 0 0 1 0 6',
  '/admin/marketing/coupons':
    'M3 7h18v4a2 2 0 0 0 0 4v4H3v-4a2 2 0 0 0 0-4Z M15 7v3 M15 13v2 M15 18v1',
  '/admin/payments/merchants': 'M3 5h18v14H3Z M3 10h18 M7 15h3',
  '/admin/messages/templates': 'M4 4h16v12H9l-5 4Z M8 8h8 M8 12h5',
  '/admin/finance/order-profit': 'M3 21h18 M6 17V9h3v8 M11 17V3h3v14 M16 17v-6h3v6',
  '/admin/system/settings':
    'M12 3l3 2 4 1 1 4-1 4-2 3-4 3-4-1-3-2-2-4 1-4 2-3Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  '/admin/security/users': 'M12 3 3 7v5c0 5 9 9 9 9s9-4 9-9V7Z M8 12l3 3 5-6',
  '/admin/audit/overview': 'M5 3h14v18H5Z M8 7h8 M8 11h8 M8 15h8 M8 18h4',
};

export function AdminModuleIcon({ href }: { href: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[href] ?? paths['/admin/apps']} />
    </svg>
  );
}
